// Arabic strings for email delivery settings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed
// until decision H-10. English source: en-email.ts.
import type { enEmail } from './en-email.ts';
import type { Message } from './types.ts';

export const arEmail: { readonly [K in keyof typeof enEmail]: Message } = {
  'eml.api.notAllowed': 'لا يُسمح لهذه المؤسسة باستخدام مُرسل بريد خاص بها. يمكن لمسؤول النظام السماح بذلك من وحدة تحكم النظام.',
  'eml.v.host': 'أدخل اسم الخادم أو عنوان IP بدون "smtp://" وبدون منفذ.',
  'eml.v.domain': 'أدخل نطاقاً مثل example.com.',
  'eml.v.envName': 'استخدم اسم متغير يبدأ بـ PASSAGE_SMTP_ (أحرف إنجليزية كبيرة وأرقام و _ فقط).',
  'eml.problem.from_missing': 'أدخل العنوان الذي تُرسل منه الرسائل.',
  'eml.problem.host_missing': 'أدخل اسم خادم SMTP.',
  'eml.problem.port_missing': 'أدخل منفذ خادم SMTP (عادةً 587 لـ STARTTLS أو 465 لـ TLS).',
  'eml.problem.security_missing': 'اختر طريقة تشفير الاتصال.',
  'eml.problem.insecure_transport': 'الاتصال غير المشفّر مسموح فقط مع خادم اختبار محلي خارج بيئة الإنتاج. اختر TLS أو STARTTLS.',
  'eml.problem.credentials_incomplete': 'أدخل اسم المستخدم وكلمة المرور معاً، أو اتركهما فارغين.',
  'eml.problem.domain_missing': 'أدخل النطاق الذي ترسل منه مؤسستك.',
  'eml.problem.from_domain_mismatch': 'يجب أن يكون عنوان المُرسل ضمن نطاق الإرسال (أو أحد نطاقاته الفرعية).',
  'eml.problem.development_domain': 'استخدم نطاقاً حقيقياً تملكه: نطاقات التطوير والأمثلة (localhost و‎.test و‎example.com …) مرفوضة في هذا النشر.',
  'eml.problem.environment_reference_not_allowed': 'تحفظ المؤسسة كلمة المرور هنا؛ مراجع متغيرات البيئة مخصصة للإعداد الافتراضي للتثبيت فقط.',

  'eml.test.subject': 'رسالة اختبار من Passage',
  'eml.test.body': 'هذه رسالة اختبار من Passage للتحقق من إعدادات مُرسل البريد. لا يلزم أي إجراء.',

  'eml.nav': 'إرسال البريد',
  'eml.provider': 'المزوّد',
  'eml.provider.development_mailbox': 'صندوق بريد التطوير (افتراضي)',
  'eml.provider.smtp': 'خادم SMTP',
  'eml.provider.none': 'متوقف',
  'eml.provider.development_mailbox.hint': 'تُكتب الرسائل في مجلد محلي على الخادم ولا تغادره. للتطوير والتقييم فقط.',
  'eml.provider.smtp.hint': 'أي مزوّد يوفّر إرسال SMTP: Amazon SES أو Microsoft 365 أو Google Workspace أو SendGrid أو Postmark أو خادم الترحيل الخاص بك.',
  'eml.provider.none.hint': 'لا يُرسل أي بريد. تُسجَّل كل رسالة بريد على أنها غير متاحة.',
  'eml.section.sender': 'المُرسل',
  'eml.section.smtp': 'اتصال SMTP',
  'eml.fromAddress': 'عنوان المُرسل',
  'eml.fromAddress.hint': 'العنوان الذي يراه المستلمون ومسار إرجاع الرسائل المرتدة.',
  'eml.fromNameEn': 'اسم المُرسل (بالإنجليزية)',
  'eml.fromNameAr': 'اسم المُرسل (بالعربية)',
  'eml.fromName.hint': 'يظهر للمستلمين بجانب العنوان؛ تستخدم الرسائل العربية الاسم العربي إن وُجد.',
  'eml.replyTo': 'عنوان الرد',
  'eml.replyTo.hint': 'اختياري. العنوان الذي تصل إليه الردود.',
  'eml.smtpHost': 'اسم الخادم',
  'eml.smtpPort': 'المنفذ',
  'eml.smtpSecurity': 'التشفير',
  'eml.security.tls': 'TLS من البداية (عادةً المنفذ 465)',
  'eml.security.starttls': 'STARTTLS إلزامي (عادةً المنفذ 587)',
  'eml.security.none': 'بدون (خادم اختبار محلي فقط)',
  'eml.security.hint': 'يُتحقق دائماً من شهادة الخادم.',
  'eml.smtpUsername': 'اسم المستخدم',
  'eml.password': 'كلمة المرور',
  'eml.password.state.none': 'لم تُعيَّن كلمة مرور.',
  'eml.password.state.stored': 'كلمة مرور محفوظة (مشفّرة). لا يمكن عرضها.',
  'eml.password.state.environment': 'تُقرأ كلمة المرور من متغير البيئة {name} على الخادم (أو {name}_FILE).',
  'eml.password.changed': 'آخر تغيير {at}.',
  'eml.password.action': 'تغيير كلمة المرور',
  'eml.password.keep': 'الإبقاء على كلمة المرور الحالية',
  'eml.password.set': 'إدخال كلمة مرور جديدة',
  'eml.password.clear': 'إزالة كلمة المرور',
  'eml.password.environment': 'قراءتها من متغير بيئة على الخادم',
  'eml.password.new': 'كلمة المرور الجديدة',
  'eml.password.new.hint': 'للكتابة فقط: تُحفظ مشفّرة ولا تُعرض مرة أخرى.',
  'eml.password.envName': 'اسم المتغير',
  'eml.password.envName.hint': 'يجب أن يبدأ بـ PASSAGE_SMTP_. يضبطه مشغّل الخادم (أو {name}_FILE) لواجهة البرمجة والعامل.',
  'eml.version': 'إصدار الإعدادات {version}، حُفظ {at}.',
  'eml.problems.title': 'لا يمكن الإرسال بهذه الإعدادات بعد',
  'eml.saved': 'حُفظت إعدادات البريد.',

  'eml.test.title': 'إرسال بريد اختبار',
  'eml.test.intro': 'يرسل رسالة اختبار قصيرة باللغتين بالإعدادات المحفوظة. احفظ تغييراتك أولاً.',
  'eml.test.to': 'الإرسال إلى',
  'eml.test.send': 'إرسال بريد اختبار',
  'eml.test.sending': 'جارٍ الإرسال…',
  'eml.test.note': '"مقبول" يعني أن الخادم استلم الرسالة، ولا يعني أنها وصلت أو قُرئت.',
  'eml.test.outcome.accepted': 'قبلها الخادم',
  'eml.test.outcome.refused': 'رفضها الخادم',
  'eml.test.outcome.deferred': 'رفضها الخادم مؤقتاً — حاول لاحقاً',
  'eml.test.outcome.not_connected': 'تعذّر الوصول إلى الخادم — لم يُرسل شيء',
  'eml.test.outcome.unknown': 'غير معروف — لم يرد الخادم في الوقت المحدد بعد تسليم الرسالة',
  'eml.test.outcome.unavailable': 'لم تُرسل — لا يمكن استخدام الإعدادات',
  'eml.test.code': 'رمز رد الخادم {code}',
  'eml.test.detail': 'التفاصيل: {detail}',
  'eml.test.version': 'إصدار الإعدادات المختبر {version}.',
  'eml.lastTest': 'آخر اختبار {at}: {outcome}',
  'eml.lastTest.none': 'لم يُرسل بريد اختبار بعد.',
  'eml.detail.email_off': 'البريد متوقف.',
  'eml.detail.destination_refused': 'عنوان هذا الخادم غير مسموح (مثل عنوان شبكة خاصة أو محلية الرابط).',
  'eml.detail.password_missing': 'لا توجد كلمة مرور محفوظة.',
  'eml.detail.secret_keys_missing': 'لا توجد لدى الخادم حلقة مفاتيح لقراءة كلمة المرور المحفوظة (MAIL_SECRET_KEYS).',
  'eml.detail.password_unreadable': 'لا يمكن قراءة كلمة المرور المحفوظة بحلقة المفاتيح الحالية. أدخلها مرة أخرى.',
  'eml.detail.password_reference_invalid': 'اسم متغير البيئة غير مسموح.',
  'eml.detail.password_reference_missing': 'متغير البيئة غير مضبوط على هذا الخادم.',
  'eml.detail.password_reference_unreadable': 'لا يمكن قراءة ملف متغير البيئة على هذا الخادم.',
  'eml.detail.timeout': 'لم يرد الخادم في الوقت المحدد.',

  'eml.platform.title': 'إرسال البريد',
  'eml.platform.intro': 'المُرسل والمزوّد المستخدمان لجميع المؤسسات ما لم يُسمح لمؤسسة بالإرسال باسمها. تسري التغييرات على الرسالة التالية دون إعادة تشغيل.',
  'eml.platform.secretKeys': 'تُشفَّر كلمات المرور المحفوظة بحلقة مفاتيح التثبيت.',
  'eml.platform.org.title': 'مُرسل البريد',
  'eml.platform.org.sub': 'هل يُسمح لهذه المؤسسة بإرسال البريد من نطاقها وخادم SMTP الخاص بها. يتولى مسؤولوها الإعداد والاختبار.',
  'eml.platform.org.allow': 'السماح لهذه المؤسسة باستخدام مُرسل خاص بها',
  'eml.platform.org.reason': 'سبب التغيير',
  'eml.platform.org.apply': 'تطبيق',
  'eml.platform.org.notConfigured': 'لم تُعدّه المؤسسة بعد.',
  'eml.inEffect.organisation': 'المستخدم حالياً: مُرسل المؤسسة الخاص',
  'eml.inEffect.installation': 'المستخدم حالياً: المُرسل الافتراضي للتثبيت',

  'eml.org.tab': 'مُرسل البريد',
  'eml.org.title': 'مُرسل البريد لمؤسستك',
  'eml.org.intro': 'تستخدم رسائلك افتراضياً مُرسل التثبيت. إذا سمح مسؤول النظام بذلك، يمكنك الإرسال من نطاقك عبر خادم SMTP الخاص بك.',
  'eml.org.notAllowed': 'تستخدم مؤسستك مُرسل التثبيت. للإرسال من نطاقك، اطلب من مسؤول النظام السماح بذلك.',
  'eml.org.installationSender': 'مُرسل التثبيت: {sender}',
  'eml.org.installationSender.none': 'مُرسل التثبيت: غير محدد (صندوق بريد التطوير)',
  'eml.org.enabled': 'استخدام مُرسلنا الخاص لرسائلنا',
  'eml.org.enabled.hint': 'يسري بعد أن يقبل الخادم بريد اختبار بالإعدادات الحالية.',
  'eml.org.sendingDomain': 'نطاق الإرسال',
  'eml.org.sendingDomain.hint': 'النطاق الذي ترسل منه. يجب أن يكون عنوان المُرسل ضمنه. اضبط SPF وDKIM له لدى مزوّدك.',
  'eml.org.verified': 'قبل الخادم بريد اختبار بهذه الإعدادات.',
  'eml.org.notVerified': 'أرسل بريد اختبار لتأكيد هذه الإعدادات. حتى ذلك الحين يُستخدم مُرسل التثبيت.',

  'comms.status.refused': 'مرفوضة',
  'comms.status.unknown': 'غير معروفة',
  'inv.msg.refused': 'رفض خادم البريد الرسالة',
  'inv.msg.unknown': 'نتيجة البريد غير معروفة (لم يؤكد الخادم)',
};
